export const defaultStep = {
  _id: "",
  title: { fr: "", en: "" },
  content: {
    title: { fr: "", en: "" },
    how: { fr: "", en: "" },
    why: { fr: "", en: "" },
  },
  settings: {
    uploadOptions: [],
    isUploadRequired: false,
  },
  comments: [],
  numberOfComments: 0,
  lastStepComment: {},
  users: [],
  requesteResponses: false,
  stepCommentRequesting: false,
};

export const defaultStepFeedback = {
  stepId: defaultStep,
  _id: "",
  stepFeedbackId: "",
  files: [],
  review: {
    comments: [],
    corrector: {
      name: "",
      correctorId: "",
      picture: "",
    },
  },
  createdAt: "",
  isReviewValidated: false,
  reviewValidationDate: "",
  rating: 5,
  donePercentage: 100,
  comment: "",
  status: "new",
  getCampaignActionGoal: 6,
};
